import { useState, useEffect } from "react";

import { apiRoot } from "../constants";
import { useAuth } from "./useAuth";

const useLocation = (id) => {
  const [location, setLocation] = useState(null);
  const [locationEvents, setLocationEvents] = useState(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { authed, token } = useAuth();

  useEffect(() => {
    if (!id) return;
    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
    };
    fetch(`${apiRoot}/locations/${id}`, {
      headers
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setLocation(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setLocation();
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setLocation();
        setLoading(false);
      });
  }, [id]);

  useEffect(() => {
    if (!id) return;

    setLoading(true);
    const headers = {
      "Content-Type": "application/json",
    };
    if (authed) {
      headers["Authorization"] = `Token ${token}`;
    }
    fetch(`${apiRoot}/locations/${id}/events`, {
      headers
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setLocationEvents(json);
            setError(false);
            setLoading(false);
          });
        } else {
          setError(true);
          setLocationEvents([]);
          setLoading(false);
        }
      })
      .catch((err) => {
        setError(true);
        setLocationEvents([]);
        setLoading(false);
      });
  }, [id, authed, token]);

  return {
    location,
    setLocation,
    locationEvents,
    error,
    loading,
  };
};

export default useLocation;
